import Autoplay from "embla-carousel-autoplay";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/shared/components/ui/carousel";
import { useBanners } from "../services";
import { Skeleton } from "@/shared/components/ui/skeleton";

export default function BannerCarousel() {
  const { data: banners, isLoading } = useBanners();
  const sortedBanners = banners ?? [];

  if (isLoading) {
    return <Skeleton className="w-full aspect-video rounded-lg bg-white/10" />;
  }

  if (sortedBanners.length === 0) {
    return null;
  }

  return (
    <Carousel
      plugins={[
        Autoplay({
          delay: 4000,
        }),
      ]}
      className="w-full"
      opts={{
        loop: true,
      }}>
      <CarouselContent>
        {sortedBanners.map((banner, index) => {
          const altText =
            banner.title ??
            `Course advert banner ${banner.displayOrder ?? index + 1}`;

          return (
            <CarouselItem
              key={`${banner.displayOrder}-${banner.imageUrl}-${index}`}>
              <a
                href={banner.linkUrl || undefined}
                target={banner.linkUrl ? "_blank" : undefined}
                rel={banner.linkUrl ? "noopener noreferrer" : undefined}
                className={`block relative w-full aspect-video rounded-lg overflow-hidden ${
                  !banner.linkUrl ? "cursor-default pointer-events-none" : ""
                }`}>
                <img
                  src={banner.imageUrl}
                  alt={altText}
                  className="w-full h-full object-cover"
                />
              </a>
            </CarouselItem>
          );
        })}
      </CarouselContent>
    </Carousel>
  );
}
